import { render, staticRenderFns } from "./AStudentTable.vue?vue&type=template&id=71c76992"
import script from "./AStudentTable.ts?vue&type=script&lang=ts&external"
export * from "./AStudentTable.ts?vue&type=script&lang=ts&external"
import style0 from "./AStudentTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports